module.exports = __webpack_public_path__ + "static/media/opensans-regular.5ada04aa.woff2";